export const SPLITS_LOGIN_PENDING_KEY = 'splits_login_pending'

// 1 hour in milliseconds - magic link requests older than this won't auto-continue
export const LOGIN_PENDING_TTL_MS = 60 * 60 * 1000

// Feature-card ids the user has read/dismissed.
export const DISMISSED_FEATURE_CARDS_KEY = 'splits.featureCards.dismissed'

export const DISMISSED_SPLITS_CONNECT_INTERSTITIAL_KEY =
  'splits.splitsConnectInterstitial.dismissed'

export const SHOW_SMALL_TRANSFERS_KEY = 'splits.smartAccounts.showDust'
